import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import usePreventClickjacking from 'helpers/hooks/usePreventingClickjacking';

function ContactPage() {
    const { t } = useTranslation(['user', 'common', 'home']);

    useEffect(() => {
        document.title = t('pages:contact');
    }, []);

    usePreventClickjacking();

    return (
        <div className="container2">
            <div className="contentPageContainer2">
                <div className="container-grande2">
                    <h4>{t('pages:repairCenter')}</h4>
                    <a>{t('user:address.Phone')}</a> +55 (31) 2391-5600 - {t('common:translation.Option2')}
                    <br />
                    <a>{t('user:info.Email')}: </a>
                    <a href="malito:centrodereparos@honeywell.com">centrodereparos@honeywell.com</a>
                    <h4>{t('home:contactPage.TechnicalSupport')}</h4>
                    <a>{t('user:address.Phone')}</a> +55 (31) 2391-5600 - {t('common:translation.Option4')} <br />
                    <a>{t('Portal')}:</a> <a href="https://sps-support.honeywell.com/s/">{t('home:contactPage.GlobalSupport')}</a>{' '}
                    <br />
                    <a href="https://www.youtube.com/playlist?list=PL9S4KGMkjpFj2Tuyy3M-US1EwSSHJjIUq">
                        {t('info.YoutubeVideo')}
                    </a>{' '}
                </div>
            </div>
        </div>
    );
}

export default ContactPage;
